module.exports = __webpack_public_path__ + "img/gamma3_ex_logo.8483f5a8.png";